import { PlusIcon } from 'assets/icons';
import AmountFilterPopoverPanel from 'components/custom-amount-filter/AmountFilterPopoverPanel';
import { AmountFilter } from 'components/custom-amount-filter/CustomAmountFilter';
import DropdownPopoverPanel from 'components/dropdown-with-search/DropdownPopoverPanel';
import { AmountFilterOperation } from 'constants/common';
import React, { FC, useState } from 'react';
import { VoidFn } from 'types/baseTypes';

interface EstimateMoreFilterPopoverPanelProps {
  data: any[];
  dataKey: string;
  selectedDraftArray: string[];
  setSelectedDraftArray: (selectedDraftArray: string[]) => void;
  setSelectedArray: (selectedArray: string[]) => void;
  searchText?: string;
  setSearchText?: (searchText: string) => void;
  dataIdKey: string;
  filterPlaceholderText: string;
  filterPlaceholderStyle: string;
  searchPlaceHolderText?: string;
  searchInputStyle?: string;
  allowSearch: boolean;
  showResultsCount: boolean;
  filterId: string;
  secondaryDataKey: string;
  searchFilterId?: string;
  operation: AmountFilterOperation;
  setOperation: (operation: AmountFilterOperation) => void;
  startValue: number;
  setStartValue: (startValue: number) => void;
  endValue: number;
  setEndValue: (endValue: number) => void;
  amountFilter: AmountFilter;
  setAmountFilter: (amountFilter: AmountFilter) => void;
  close: VoidFn;
}

const EstimateMoreFilterPopoverPanel: FC<EstimateMoreFilterPopoverPanelProps> = ({
  data,
  dataKey,
  selectedDraftArray,
  setSelectedDraftArray,
  setSelectedArray,
  dataIdKey,
  filterPlaceholderText,
  filterPlaceholderStyle,
  showResultsCount,
  filterId,
  secondaryDataKey,
  close,
  operation,
  setOperation,
  startValue,
  endValue,
  setStartValue,
  setEndValue,
  amountFilter,
  setAmountFilter
}) => {
  const [filterOption, setFilterOption] = useState(null);
  const filterOptions = [
    {
      label: 'Lead source',
      value: 'leadSource'
    },
    {
      label: 'Amount',
      value: 'amount'
    }
  ];
  return (
    <div
      className={
        (open ? 'block ' : 'hidden ') + 'z-50 pt-4  list-none rounded-md border border-[#ACB5BD] w-fit min-w-[208px]'
      }
      style={{
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
      }}>
      {!filterOption && (
        <div className="flex flex-col gap-y-4 px-3 pb-2.5">
          {filterOptions.map((option, index) => (
            <div
              className="flex cursor-pointer gap-x-3"
              key={`more-filter-option-${index + 1}`}
              onClick={() => setFilterOption(option.value)}>
              <PlusIcon className="shrink-0" />
              <div className="text-sbase font-semibold text-primaryText">{option.label}</div>
            </div>
          ))}
        </div>
      )}
      {filterOption === 'leadSource' && (
        <DropdownPopoverPanel
          data={data}
          dataKey={dataKey}
          selectedDraftArray={selectedDraftArray}
          setSelectedDraftArray={setSelectedDraftArray}
          setSelectedArray={setSelectedArray}
          dataIdKey={dataIdKey}
          filterPlaceholderText={filterPlaceholderText}
          filterPlaceholderStyle={filterPlaceholderStyle}
          allowSearch={false}
          showResultsCount={showResultsCount}
          filterId={filterId}
          secondaryDataKey={secondaryDataKey}
          close={close}
        />
      )}
      {filterOption === 'amount' && (
        <AmountFilterPopoverPanel
          operation={operation}
          setOperation={setOperation}
          startValue={startValue}
          setStartValue={setStartValue}
          endValue={endValue}
          setEndValue={setEndValue}
          amountFilter={amountFilter}
          setAmountFilter={setAmountFilter}
          close={close}
        />
      )}
    </div>
  );
};

export default EstimateMoreFilterPopoverPanel;
